import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../components/shared/Modal';
import errorMessage from '../../../assets/img/512PX/Icono_Advertencia_512px.png';
import './styles.scss';

export const Error_Modal = ({isOpen, toggle, messageModal='Error', lastOpenModal, setOpenModal, setOpenModalError,buttonName='Aceptar'}) => {

    const handleReturnOpenModal = () => {
        if(lastOpenModal){
            setOpenModal(lastOpenModal);
        }else{
            setOpenModalError(null);
        }
    }
    
    const modalBody = () => {
        return (
            <div className='container-errorModal'>
                <img src={errorMessage} alt="" className="errorModal-img" />
                <h3 className="errorModal-text">
                    {messageModal}
                </h3>

                <button className="errorModal-button" onClick={handleReturnOpenModal}>
                    {buttonName}
                </button>
            </div>
        );
    };

    return (
        <CustomModal
                isOpen={isOpen}
                toggle={toggle}
                title=""
                body={modalBody()}
        />
    );
}

Error_Modal.propTypes = {
    isOpen: PropTypes.any,
    toggle: PropTypes.any,
    messageModal: PropTypes.any,
    lastOpenModal: PropTypes.any,
    setOpenModal: PropTypes.any,
    setOpenModalError: PropTypes.any,
};
  
